import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import AllocationStatusActionableFilterPill from '../../../../components/actionable-filter-pill/connected/orders/allocation-status';
import { messages } from './messages';

export const AllocationStatus = {
  id: 'allocationStatus',
  isInventoryFilter: true,
  type: OptionFormTypes.TYPE_BOOLEAN,
  filterValue: 'IsAllocated',
  displayName: <FormattedMessage {...messages.allocationStatus} />,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations);
  },

  actionableFilterPill: AllocationStatusActionableFilterPill,
};
